import * as ActionTypes from "./actionTypes"
import {createActionObject} from '../../../redux/utils'

export const openTeamAssignmentsPanel = () => dispatch => {
    dispatch(createActionObject(ActionTypes.SHOW_SET, true))
}

export const closeTeamAssignmentsPanel = () => (dispatch) => {
    dispatch(createActionObject(ActionTypes.SHOW_SET, false))
}



// WEBPACK FOOTER //
// ./web/js/panels/user/createTeamAssignmentsPanel/actions.js